export const withoutEmptyProperties =(obj) => {
  const newObj = { ...obj };
  for (const key in obj) {
    if (typeof obj[key] !== 'boolean' && typeof obj[key] !== 'number' && !obj[key]) {
      delete newObj[key];
    }
  }
  return newObj;
};
